import React, { useEffect, useState } from "react";
import { string, func, bool } from "prop-types";
import * as style from "./styles.module.scss";
import * as style2 from "../ReadingListDownload/styles.module.scss";
import Checkbox from "../../common/Checkbox/index";
import Spinner from "../../common/Spinner";

const ConfirmPDFResource = ({
  title,
  description,
  downloadPDFFile,
  agreementText,
  hasFile,
  submitResourceAgreement,
  forceDownloadViaSnackbar,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [agreed, setAgreed] = useState(false);
  const [loading, setLoading] = useState(false);

  const downloadHandler = async () => {
    const fileFound = hasFile;

    if (!fileFound && !agreed) {
      setLoading(true);
      await downloadPDFFile(false);
      setOpenModal(true);
      setLoading(false);
    } else {
      setLoading(true);
      await downloadPDFFile(true);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (forceDownloadViaSnackbar) {
      downloadHandler();
    }
  }, []);

  const acceptHandler = async () => {
    setLoading(true);
    setAgreed(true);
    await submitResourceAgreement();
    setOpenModal(false);
    setLoading(false);
  };

  return (
    <div className={style.resource__wrapper}>
      <h4 className={style.resource__title}>{title}</h4>
      <p className={style.resource__description}>
        <b>{description}</b>
      </p>

      <span className="d-flex justify-content-end">
        <button
          disabled={loading ? "disabled" : ""}
          style={openModal ? { marginBottom: "15px" } : null}
          className={`btn btn-block btn-primary ${style.resource__button}`}
          onClick={() => downloadHandler()}
        >
          {loading ? <Spinner /> : "Download"}
        </button>
      </span>

      {openModal ? (
        <div className={`${style2.rldownload__agreementWrapper}`}>
          <div className={`d-flex flex-column`}>
            <div
              style={{
                display: "flex",
                flexFlow: "row",
                marginLeft: "15px",
                marginTop: "10px",
              }}
            >
              <Checkbox onClick={() => acceptHandler()} />
              <p style={{ width: "85%" }}>
                {agreementText || `I've read and understood the ${title}.`}
              </p>
            </div>
          </div>

          <div style={{ margin: "10px", alignSelf: "flex-end" }}>
            <button
              onClick={() => {
                setAgreed(false);
                setOpenModal(false);
              }}
              style={{ maxWidth: "130px" }}
              className={`${style2.rldownload__button} btn btn-sm btn-outline mx-1 mx-sm-0`}
            >
              Cancel
            </button>
          </div>
        </div>
      ) : null}
    </div>
  );
};

ConfirmPDFResource.propTypes = {
  title: string.isRequired,
  description: string.isRequired,
  downloadPDFFile: func,
  agreementText: string,
  hasFile: bool,
  submitResourceAgreement: func,
  forceDownloadViaSnackbar: bool,
};

export default ConfirmPDFResource;
